module.exports = __webpack_public_path__ + "static/media/panamerican.c45035ad.png";